// extracted by mini-css-extract-plugin
export default {"wrapper":"TicToe_wrapper__Y7gsh","gameWrapper":"TicToe_gameWrapper__wb1ZZ"};